// Handling login APIs

jQuery(function ($) {
  const formElm = $('#form-governance-login');
  const usernameElm = $('#username');
  const passwordElm = $('#password');
  const errorMessageElm = $('#login-error-message');
  const buttonElm = $('#button-governance-login');
  const loader = $('#loader-governance-login');

  const redirectPath = formElm.data('redirect');

  formElm.on('submit', function(e) {
    e.preventDefault();

    errorMessageElm.html('');
    buttonElm.prop('disabled', true);
    buttonElm.css('pointer-events', 'none');
    buttonElm.css('opacity', '0.5');
    loader.show();

    var data = {
      name: usernameElm.val(),
      pass: passwordElm.val(),
    };

    $.ajax({
      url: "/user/login?_format=json",
      method: "POST",
      data: JSON.stringify(data),
      dataType: "json",
      headers: {
        "Content-Type": "application/json",
      },
      success: function (response) {
        // Authentication successful
        localStorage.setItem("idea-logout-token", response.logout_token);
        window.location = redirectPath;
      },
      error: function (xhr, status, error) {
        console.log('xhr', xhr);
        console.log('xhr.status', xhr.status);
        console.log('xhr.responseJSON.message', xhr.responseJSON.message);
        console.log('status', status);
        console.log('error', error);

        // Authentication failed
        if (xhr.status === 403) {
          // errorMessageElm.html('You are already logged in. Click <a class="tema-text--link" href="' + redirectPath + '">here</a> to go to Governance Overview.');
          errorMessageElm.html(xhr.responseJSON.message);
        }

        if (xhr.status === 400) {
          errorMessageElm.html('Invalid username and/or password');
          usernameElm.trigger('focus');
        }

        buttonElm.prop('disabled', false);
        buttonElm.css('pointer-events', 'auto');
        buttonElm.css('opacity', '1');
        loader.hide();
      },
    });

  });

  $('.user-logout').on('click', function(){
    console.log('logging out...');
  
    const logout_token = localStorage.getItem("idea-logout-token");
  
    $.ajax({
      url: "/session/token",
      method: "GET",
      success: function(response) {
        $.ajax({
          url: "/user/logout?_format=json&token=" + logout_token,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": response,
            // "Authorization": "Bearer " + sessionStorage.getItem("session_token"),
            // "X-Logout-Token": "gvUoUIFB58_TQKfJRi_jbU9qslNoj9Dnj39JqA-o99s"
          },
          success: function(response) {
            // Log out successful
            console.log('logged out');
            sessionStorage.removeItem("session_token");
            window.location = '/';
          },
          error: function(xhr, status, error) {
            // Log out failed
            console.log(xhr.responseText);
          }
        });
      },
      error: function(xhr, status, error) {
        // Log out failed
        console.log(xhr.responseText);
      }
    });
  });
});
